import { GeoserverWMSProvider } from '../GeoserverWMSProvider'
import { WmsBaseLayer } from './WmsBaseLayer'

export class WmsDwLayer extends WmsBaseLayer {
  layername: string = '水深图层'
  key: string = 'wmsDw'
  provider = new GeoserverWMSProvider({
    url: 'iserver/services/map-ugcv5-dwdata/wms111/dwdata',
    layers: 'dwdata',
  })
}
